import React from 'react';
import PropTypes from 'prop-types';
import { PostHogProvider } from 'posthog-js/react';
import { posthog } from "posthog-js";

// analytic url with origin 
const ANALYTICS_URL= `https://${process.env.REACT_APP_ANALYTICS_URL}/logs`


if (process.env.REACT_APP_DISABLE_POSTHOG === "false") {
  posthog.init(
    process.env.REACT_APP_ANALYTICS_KEY,
    {
      api_host: ANALYTICS_URL,
    }
  );

  posthog.register({
    'airbus-aspire-code': process.env.REACT_APP_ASPIRE,
    'airbus-app-env': process.env.REACT_APP_STAGE,
    'airbus-app-dashboard': 'ED',
  });
}
const PostHogProviderWrapper = ({ isLocal, children }) => {
  if (isLocal) {
    return <>{children}</>;
  } else {
    return (
      <PostHogProvider client={posthog}>
        {children}
      </PostHogProvider>
    );
  }
};
PostHogProviderWrapper.propTypes = {
  children: PropTypes.node,
  isLocal: PropTypes.bool
};

export default PostHogProviderWrapper;